module.exports = __webpack_public_path__ + "static/media/apexredsmall.756aa2f1.gif";